// reducer.js
import {
  ADD_NEW_Payment_SUCCESS,
  ADD_NEW_Payment_FAIL,
  GET_PARTICIPANT_PAYMENT_SUCCESS,
  GET_PARTICIPANT_PAYMENT_FAIL,
  GET_PARTICIPANT_SCHEME_LIST_SUCCESS,
  GET_PARTICIPANT_SCHEME_LIST_FAIL,
  UPDATE_NEW_PAYMENT_SUCCESS,
  UPDATE_NEW_PAYMENT_FAIL,
  GET_DELETED_PAYMENTS_SUCCESS,
  GET_DELETED_PAYMENTS_FAIL,
  DELETE_PAYMENT_SUCCESS,
  CONFIRM_PAYMENT_SUCCESS,
  CONFIRM_PAYMENT_FAIL,
  GET_ANALYTE_REPORT2_SUCCESS,
  GET_ANALYTE_REPORT2_FAIL,
  GET_ANALYTE_EVALUATION_REPORT_SUCCESS,
  GET_ANALYTE_EVALUATION_REPORT_FAIL,
  GET_PARTICIPANT_PERFORMANCE_REPORT_FAIL,
  GET_PARTICIPANT_PERFORMANCE_REPORT_SUCCESS,
  GET_ANALYTE_EVALUATION_LAB_SUCCESS,
  GET_ANALYTE_EVALUATION_LAB_FAIL,
  GET_FINANCIAL_FORECAST_SUCCESS,
  GET_FINANCIAL_FORECAST_FAIL,
  // DELETE_PAYMENT_FAIL
} from "./actionTypes";

const INIT_STATE = {
  AddPayment: [],
  GetPayment: [],
  PaymentSchemeList: [],
  GetFinancialForecast: [],
  participant_name: "",
  membership_status: "",
  GetAnalyteEvaluation: [],
  GetAnalyteEvaluationLab: [],
  price: "",
  discount: "",
  paid_amount: "",
  pay_date: "",
  payment_mode: "",
  received_by: "",
  photo_url: "",
  error: {},
};

const AddPayment = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_NEW_Payment_SUCCESS:
      return {
        ...state,
        AddPayment: [...state.AddPayment, action.payload.data],
      };

    case ADD_NEW_Payment_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_PARTICIPANT_PAYMENT_SUCCESS:
      return {
        ...state,
        GetPayment: action.payload || [],
      };

    case GET_PARTICIPANT_PAYMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_NEW_PAYMENT_SUCCESS:
      if (!action.payload || !action.payload.id) {
        return state; // return unchanged state to prevent crashing
      }

      return {
        ...state,
        GetPayment: state.GetPayment.map((payment) =>
          payment?.id?.toString() === action.payload.id.toString()
            ? { ...payment, ...action.payload }
            : payment,
        ),
      };

    case UPDATE_NEW_PAYMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_PARTICIPANT_SCHEME_LIST_SUCCESS:
      return {
        ...state,
        PaymentSchemeList: Array.isArray(action.payload.schemes)
          ? action.payload.schemes
          : [],
        participant_name: action.payload.participant_name || "Unknown",
        membership_status: action.payload.membership_status || "Unknown",
        price: action.payload.price || "",
        discount: action.payload.discount || "",
        paid_amount: action.payload.paid_amount || "",
        pay_date: action.payload.pay_date || "",
        payment_mode: action.payload.payment_mode || "",
        received_by: action.payload.received_by || "",
        original_price: action.payload.original_price || "",
        photo_url: action.payload.photo_url || "", // <-- add here too!
        csrcomments: action.payload.csrcomments || "",
        csr_staff: Array.isArray(action.payload.csr_staff)
          ? action.payload.csr_staff
          : state.csr_staff || [],
        error: null,
      };
    case GET_DELETED_PAYMENTS_SUCCESS:
      return { ...state, DeletedPayments: action.payload || [] };

    case GET_DELETED_PAYMENTS_FAIL:
      return { ...state, error: action.payload };
    case DELETE_PAYMENT_SUCCESS:
      return {
        ...state,
        GetPayment: state.GetPayment.filter((p) => p.id !== action.payload),
      };

    case DELETE_PAYMENT_SUCCESS:
      return {
        ...state,
        GetPayment: state.GetPayment.filter((p) => p.id !== action.payload),
      };

    case CONFIRM_PAYMENT_SUCCESS:
      console.log("CONFIRM_PAYMENT_SUCCESS:", action.payload);
      return {
        ...state,
        confirmpayment: action.payload || [], // Ensure it's always an array
      };

    case CONFIRM_PAYMENT_SUCCESS:
      return {
        ...state,
        confirmpayment: action.payload || [], // Ensure it's always an array
      };

    case CONFIRM_PAYMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_ANALYTE_REPORT2_SUCCESS:
      return {
        ...state,
        GetAnalyte: action.payload || [],
      };

    case GET_ANALYTE_REPORT2_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_ANALYTE_EVALUATION_REPORT_SUCCESS:
      return {
        ...state,
        GetAnalyteEvaluation: action.payload || [],
      };

    case GET_ANALYTE_EVALUATION_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_PARTICIPANT_PERFORMANCE_REPORT_SUCCESS:
      return {
        ...state,
        // GetParticipantEvaluation: action.payload || [],
        GetParticipantEvaluation: action.payload.data || {},
      };

    case GET_PARTICIPANT_PERFORMANCE_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_ANALYTE_EVALUATION_LAB_SUCCESS:
      return {
        ...state,
        GetAnalyteEvaluationLab: action.payload, // keep full payload
      };

    case GET_ANALYTE_EVALUATION_LAB_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_FINANCIAL_FORECAST_SUCCESS:
      return {
        ...state,
        GetFinancialForecast: action.payload || [],
      };

    case GET_FINANCIAL_FORECAST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default AddPayment;
